<template>
  <Box>
    <template #handle>
      <!-- <Btn>批量处理数据状态</Btn> -->
    </template>
    <template #content>
      <div class="table_main">
        <div class="query">
          <div class="left">
            <el-form ref="query_form" :model="queryParams" label-width="80px">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="采集时间" prop="cjtime">
                    <el-date-picker v-model="queryParams.cjtime" type="daterange" range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                      size="small">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="上传时间" prop="sctime">
                    <el-date-picker v-model="queryParams.sctime" type="daterange" range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                      size="small">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="上报时间" prop="sbtime">
                    <el-date-picker v-model="queryParams.sbtime" type="daterange" range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                      size="small">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="加工年度" prop="nd">
                    <el-date-picker v-model="queryParams.nd" type="year" placeholder="选择年" format="yyyy"
                      value-format="yyyy" size="small">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="区域" prop="qy">
                    <Region :qy="queryParams.qy" @change="change" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="加工类型" prop="jglx">
                    <el-select v-model="queryParams.jglx" size="small" clearable>
                      <el-option v-for="item in jglx" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label-width="112px" label="企业/企业代码" prop="companycode">
                    <el-select v-model="queryParams.companycode" size="small" filterable clearable>
                      <el-option v-for="item in componany" :key="item.id" :label="item.companycode + ' | ' + item.companyname" :value="item.companycode">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="数据状态" prop="datastate">
                    <el-select v-model="queryParams.datastate" size="small" clearable>
                      <el-option v-for="item in datastate" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="上报状态" prop="upstate">
                    <el-select v-model="queryParams.upstate" size="small" clearable>
                      <el-option v-for="item in shangbzt" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="异性纤维" prop="yxxw">
                    <el-select v-model="queryParams.yxxw" size="small" clearable>
                      <el-option v-for="item in yxxw" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="right">
            <Btn @click="query" round>
              <span class="btn_box">
                <i class="iconfont icon-sousuo"></i>
                <span>搜索</span>
              </span>
            </Btn>
            <Btn @click="initQuery" round>
              <span class="btn_box">
                <i class="iconfont icon-chongzhi"></i>
                <span>重置</span>
              </span>
            </Btn>
          </div>
        </div>
        <div class="querymsg">
          <el-row>
            <el-col :span="4" :offset="1">
              <span>总包数：</span><span>{{ queryMsg.bCount }}</span>
            </el-col>
            <el-col :span="4" :offset="1">
              <span>总皮重：</span><span>{{ queryMsg.pCount ? `${queryMsg.pCount}Kg` : '' }}</span>
            </el-col>
            <el-col :span="4" :offset="1">
              <span>总毛重：</span><span>{{ queryMsg.mCount ? `${queryMsg.mCount}Kg` : '' }}</span>
            </el-col>
            <el-col :span="4" :offset="1">
              <span>总净量：</span><span>{{ queryMsg.jCount ? `${queryMsg.jCount}Kg` : '' }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :offset="1">
              <span>棉包平均皮重：</span><span>{{ queryMsg.ppCount ? `${queryMsg.ppCount}Kg` : '' }}</span>
            </el-col>
            <el-col :span="4" :offset="1">
              <span>棉包平均毛重：</span><span>{{ queryMsg.mpCount ? `${queryMsg.mpCount}Kg` : '' }}</span>
            </el-col>
            <el-col :span="4" :offset="1">
              <span>棉包平均净重：</span><span>{{ queryMsg.jpCount ? `${queryMsg.jpCount}Kg` : '' }}</span>
            </el-col>
          </el-row>
        </div>
        <div class="content">
          <Table :datas="tableData" :heads="tableHead" :selection="true" :loading="loading">
            <template #handle="data">
              <div class="table_cell">
                <span v-if="data.head.handle == 'index'">{{
                (pageData.page - 1) * pageData.pageSize + data.index
                }}</span>
              </div>
            </template>
          </Table>
          <el-pagination class="page" background layout="total, sizes, prev, pager, next" :total="pageData.total" :page-sizes = "[10, 20, 50, 100]"
            :current-page.sync="pageData.page" :page-size.sync="pageData.pageSize" @current-change="getList" @size-change="query">
          </el-pagination>
        </div>
      </div>
    </template>
  </Box>
</template>

<script>
import {
  jglx,
  datastate,
  shangbzt,
  yxxw
} from "@/utils/status";
import queryCompany from "@/api/queryCompanyByUser";
import {
    cjywfzStatistics
} from "@/api/BusinessDataManagement";
import permMixin from "@/mixins/perm";
import Region from "@/components/region";
export default {
  mixins: [permMixin],
  components: { Region },
  data() {
    return {
      jglx,
      datastate,
      shangbzt,
      yxxw,
      loading: false,
      queryTime: null,
      queryCount: 0,
      queryParams: {
        cjtime: [],
        sctime: [],
        sbtime: [],
        nd: "",
        qy: "",
        jglx: "",
        companyname: "",
        companycode: "",
        datastate: "",
        upstate: "",
        yxxw: null,
      },
      tableHead: [
        {
          prop: "xh",
          label: "序号",
          handle: "index",
          width: 50,
          textAlign: "center",
        },
        {
          prop: "processingAnnual",
          label: "加工年度",
          textAlign: "center",
        },
        {
          prop: "companyname",
          label: "企业名称",
          minWidth: 200,
        },
        {
          prop: "companycode",
          label: "企业代码",
          textAlign: "center",
        },
        {
          prop: "bCount",
          label: "总包数",
        },
        {
          prop: "pCount",
          label: "总皮重(Kg)",
        },
        {
          prop: "mCount",
          label: "总毛重(Kg)",
        },
        {
          prop: "jCount",
          label: "总净重(Kg)",
        },
        {
          prop: "ppCount",
          label: "棉包平均皮重(Kg)",
          minWidth: 50,
        },
        {
          prop: "mpCount",
          label: "棉包平均毛重(Kg)",
          minWidth: 50,
        },
        {
          prop: "jpCount",
          label: "棉包平均净重(Kg)",
          minWidth: 50,
        },
      ],
      tableData: [],
      componany: [],
      queryMsg: {},
      pageData: {
        total: 0,
        page: 1,
        pageSize: 10,
      },
      addForm: {},
    };
  },
  methods: {
    change(val) {
      this.queryParams.qy = val;
    },
    initQuery() {
      this.pageData.page = 1;
      this.$refs.query_form.resetFields();
      this.queryParams.qy = "";
    },
    query() {
      this.pageData.page = 1;
      this.getList();
    },
    getComponany() {
      queryCompany()
        .then((res) => {
          this.componany = res.data;
        })
        .catch((err) => {
          this.componany = [];
        });
    },
    getList() {
      this.loading = true
      const params = {
        ...this.queryParams,
        currentPage: this.pageData.page,
        pageSize: this.pageData.pageSize
      };
      if (this.queryParams.cjtime?.length) {
        params.cjTimeStart = this.queryParams.cjtime[0];
        params.cjTimeEnd = this.queryParams.cjtime[1];
      }
      if (this.queryParams.sctime?.length) {
        params.uploadTimeStart = this.queryParams.sctime[0];
        params.uploadTimeEnd = this.queryParams.sctime[1];
      }
      if (this.queryParams.sbtime?.length) {
        params.reportTimeStart = this.queryParams.sbtime[0];
        params.reportTimeEnd = this.queryParams.sbtime[1];
      }
      delete params.cjtime;
      delete params.sctime;
      delete params.sbtime;
      cjywfzStatistics(params)
        .then((res) => {
          this.pageData.total = res.data.count;
          this.tableData = res.data?.list || [];
          this.queryMsg = res.data.cjywStatisticsTRes;
          this.loading = false
        })
        .catch((err) => {
          this.pageData.total = 0;
          this.tableData = [];
          this.queryMsg = {};
          this.loading = false
        });
    },
  },
  created() {
    this.getComponany();
    this.getList();
  },
};
</script>

<style scoped lang="scss">
.table_main .query {
  min-height: 120px;
}

.querymsg {
  box-sizing: border-box;
  padding-left: 10px;
  font-size: 13px;

  .el-row {
    margin-top: 6px;
  }
}

.queryTime {
  >div {
    display: inline-block;
    margin-right: 10px;
  }
}

.red {
  color: $hong;
}
</style>
